module.exports = __webpack_public_path__ + "static/media/template-categories.069dbf47.csv";